export default __webpack_public_path__ + "static/media/01_downloading_template.5deccabc.png";